import { useState } from "react";
import EditTab from "./EditTab";
import TemplatesTab, { filteredTemplates } from "./TemplatesTab";
import ContentTab from "./ContentTab";
import DesignService from "../assets/design_services.svg";
import DesignServiceActive from "../assets/design_services_active.svg";
import Article from "../assets/article.svg";
import ArticleActive from "../assets/article_active.svg";
import Folder from "../assets/folder.svg";
import FolderActive from "../assets/folder_active.svg";

function LeftSideBar({
  activeTab,
  setActiveTab,
  templateData,
  setTemplateData,
  originTemplateData,
  selectedTemplate,
  setSelectedTemplate,
  form,
  onValuesChange,
  backgroundAndResize,
  updateWithUndo,
  effects,
  setEffects,
  setSelectedRatio,
  addLayer,
  addOrUpdatePreset,
  isFcbTemplate,
  setManualEntries,
  manualEntries,
  presetBgColor,
  addOrUpdateGkPreset,
  presetGkColor,
  setCLStarsOnOrOff,
  setCropOption,
  cropOption,
  setSelectedJersey,
  setSelectedResultTime
}) {
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [reservedPlayers, setReservedPlayers] = useState([]);
  const template_name = templateData?.template_name;
  const isResult = template_name === 'fcb_results';
  return (
    <div className={`editor-sidebar left ${activeTab === 'Content' ? "side-max" : ""}`}>
      <div className="tab-section">
        <div
          className={`tab ${activeTab === "Edit" && "active"}`}
          onClick={() => setActiveTab("Edit")}
        >
          <img
            src={activeTab === "Edit" ? DesignServiceActive : DesignService}
          />
          Edit
        </div>
        {
          !filteredTemplates.includes(templateData.template_name) &&
          <div
            className={`tab ${activeTab === "Templates" && "active"}`}
            onClick={() => setActiveTab("Templates")}
          >
            <img src={activeTab === "Templates" ? FolderActive : Folder} />
            Templates
          </div>
        }

        <div
          className={`tab ${activeTab === "Content" && "active"}`}
          onClick={() => setActiveTab("Content")}
        >
          <img src={activeTab === "Content" ? ArticleActive : Article} />
          Content
        </div>
      </div>
      <div>
        {activeTab === "Edit" ? (
          <EditTab
            backgroundAndResize={backgroundAndResize}
            updateWithUndo={updateWithUndo}
            effects={effects}
            setEffects={setEffects}
            setSelectedRatio={setSelectedRatio}
            addLayer={addLayer}
            addOrUpdatePreset={addOrUpdatePreset}
            isFcbTemplate={isFcbTemplate}
            templateData={templateData}
            addOrUpdateGkPreset={addOrUpdateGkPreset}
            setCLStarsOnOrOff={setCLStarsOnOrOff}
            cropOption={cropOption}
            setCropOption={setCropOption}
            setSelectedJersey={setSelectedJersey}
            setSelectedResultTime={setSelectedResultTime}
          />
        ) : activeTab === "Templates" ? (
          <TemplatesTab
            templateData={templateData}
            setTemplateData={setTemplateData}
            selectedTemplate={selectedTemplate}
            setSelectedTemplate={setSelectedTemplate}
            setSelectedPlayers={setSelectedPlayers}
            setReservedPlayers={setReservedPlayers}
            originTemplateData={originTemplateData}
          />
        ) : activeTab === "Content" ? (
          <ContentTab
            form={form}
            onValuesChange={onValuesChange}
            selectedTemplate={selectedTemplate}
            selectedPlayers={selectedPlayers}
            reservedPlayers={reservedPlayers}
            templateData={templateData}
            setTemplateData={setTemplateData}
            setManualEntries={setManualEntries}
            manualEntries={manualEntries}
            presetBgColor={presetBgColor}
            presetGkColor={presetGkColor}
          />
        ) : null}
      </div>
    </div>
  );
}

export default LeftSideBar;
